import { render } from "./avis.vue?vue&type=template&id=7f523597&scoped=true"
import script from "./avis.vue?vue&type=script&lang=js"
export * from "./avis.vue?vue&type=script&lang=js"

import "./avis.vue?vue&type=style&index=0&id=7f523597&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f523597"]])

export default __exports__